import React, { useEffect, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useAuth } from "../context/AuthContext";
import Sev1 from "./seven/sev1";
import Sev2 from "./seven/sev2";
import Sev3 from "./seven/sev3";
import Sev4 from "./seven/sev4";

export default function Sell() {
  const { user, chatData } = useAuth();
  const [showSev1, setShowSev1] = useState(false);
  const [showSev2, setShowSev2] = useState(false);
  const [showSev3, setShowSev3] = useState(false);
  const [showSev4, setShowSev4] = useState(false);

  return (
    <div style={{ height: "90vh" }}>
      <div
        className="bg-gray-800 w-full flex justify-center text-center items-center"
        style={{ backgroundColor: "rgb(22, 19, 22)", height: "60%" }}
      >
        <div className="flex justify-center flex-col items-center px-10">
          <img src="../images/sell_main.png" alt="" />
          <p className="text-gray-200 text-2xl">Quick and Easy</p>
          <p className="text-gray-400 text-md">
            List, sell and get paid. it's all here, right in one convenient
            place
          </p>
          <div className="mt-4 flex gap-2">
            <div className="h-3 w-3 bg-gray-200 rounded-full"></div>
            <div className="h-3 w-3 bg-gray-500 rounded-full"></div>
          </div>

          <div className="mt-4">
            <p className="text-blue-400">Learn How It Works</p>
          </div>

          {user?.seven === "yes" ? (
            <div className="mt-2 flex gap-3">
              <div
                onClick={() => {
                  setShowSev1(true);
                }}
                className="text-white border border-white px-2 text-sm"
              >
                1
              </div>
              <div
                onClick={() => {
                  setShowSev2(true);
                }}
                className="text-white border border-white px-2 text-sm"
              >
                2
              </div>
              <div
                onClick={() => {
                  setShowSev3(true);
                }}
                className="text-white border border-white px-2 text-sm"
              >
                3
              </div>
              <div
                onClick={() => {
                  setShowSev4(true);
                }}
                className="text-white border border-white px-2 text-sm"
              >
                4
              </div>
            </div>
          ) : (
            " "
          )}
        </div>
      </div>

      <div className="flex justify-center -mt-5">
        <p className="bg-blue-700 w-10/12 p-3 rounded text-gray-200 font-semibold text-sm text-center">
          Sell Your Tickets
        </p>
      </div>

      <div className="px-4 mt-8">
        <div className="flex justify-between">
          <div className="flex flex-1 gap-2 items-center">
            <img src="../images/tick_sell.png" alt="" />
            <p className="text-md text-gray-800 font-medium">
              Tickets I'm Selling
            </p>
          </div>
          <div className="text-gray-800">
            <MdKeyboardArrowRight size={27} />
          </div>
        </div>
      </div>

      <div className="px-4 mt-14">
        <div className="flex justify-between">
          <div className="flex flex-1 gap-2 items-center">
            <img src="../images/sold_tickets.png" alt="" />
            <p className="text-md text-gray-800 font-medium">Sold Tickets</p>
          </div>
          <div className="text-gray-800">
            <MdKeyboardArrowRight size={27} />
          </div>
        </div>
      </div>

      <div className="px-4 mt-14">
        <div className="flex justify-between">
          <div className="flex flex-1 gap-2 items-center">
            <img src="../images/sold_tickets.png" alt="" />
            <p className="text-md text-gray-800 font-medium">Expired Tickets</p>
          </div>
          <div className="text-gray-800">
            <MdKeyboardArrowRight size={27} />
          </div>
        </div>
      </div>

      {/* authorization page here */}
      {showSev1 && (
        <Sev1
          OnClose={() => {
            setShowSev1(false);
          }}
        />
      )}

      {showSev2 && (
        <Sev2
          OnClose={() => {
            setShowSev2(false);
          }}
        />
      )}

      {showSev3 && (
        <Sev3
          OnClose={() => {
            setShowSev3(false);
          }}
        />
      )}

      {showSev4 && (
        <Sev4
          OnClose={() => {
            setShowSev4(false);
          }}
        />
      )}
    </div>
  );
}
